const cache = new Map();

function arquivoDoIcone(url) {
  const partes = String(url || '').split('/');
  return partes[partes.length - 1] || '';
}

function tamanhoDoIcone(url) {
  const arquivo = arquivoDoIcone(url);
  if (arquivo === 'triangle.png') return 30;
  if (arquivo === 'placemark_square.png') return 14;
  return 16;
}

function hexParaRgb(cor) {
  const hex = String(cor || '#808080').replace('#', '');
  const full = hex.length === 3 ? hex.split('').map((char) => char + char).join('') : hex;
  return [
    parseInt(full.slice(0, 2), 16) || 0,
    parseInt(full.slice(2, 4), 16) || 0,
    parseInt(full.slice(4, 6), 16) || 0,
  ];
}

function carregarIcone(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(url));
    image.src = url;
  });
}

function tingirIcone(image, cor, tamanho) {
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const context = canvas.getContext('2d');
  context.drawImage(image, 0, 0);
  const imagem = context.getImageData(0, 0, canvas.width, canvas.height);
  const dados = imagem.data;
  const [r, g, b] = hexParaRgb(cor);
  for (let i = 0; i < dados.length; i += 4) {
    if (dados[i + 3] < 16) continue;
    const luz = (dados[i] + dados[i + 1] + dados[i + 2]) / 3;
    if (luz < 150) {
      dados[i] = 0;
      dados[i + 1] = 0;
      dados[i + 2] = 0;
    } else {
      dados[i] = r;
      dados[i + 1] = g;
      dados[i + 2] = b;
    }
  }
  context.putImageData(imagem, 0, 0);
  return {
    data: context.getImageData(0, 0, canvas.width, canvas.height),
    pixelRatio: image.width / tamanho,
  };
}

export async function garantirIconesKmz(map, collection, ativo) {
  const pares = new Map();
  ((collection && collection.features) || []).forEach((feature) => {
    const properties = feature.properties || {};
    const url = properties.iconeUrl;
    if (!url || !feature.geometry || feature.geometry.type !== 'Point') return;
    const cor = properties.corResolvida || '#808080';
    pares.set(`${url}|${cor}`, { url, cor });
  });
  await Promise.all([...pares.entries()].map(async ([id, { url, cor }]) => {
    if (!ativo() || !map.getStyle() || map.hasImage(id)) return;
    let bitmap = cache.get(id);
    if (!bitmap) {
      const image = await carregarIcone(url);
      bitmap = tingirIcone(image, cor, tamanhoDoIcone(url));
      cache.set(id, bitmap);
    }
    if (!ativo() || !map.getStyle() || map.hasImage(id)) return;
    map.addImage(id, bitmap.data, { pixelRatio: bitmap.pixelRatio });
  }));
}
